<template>
  <div
    class="sn-ssn"
  >
    <sn-label
      v-if="label"
      class="mb-2"
      :title="label"
      :optional="showOptionalLabel"
    />
    <v-text-field
      :id="snInputProps_identifier"
      v-model="response"
      :data-cy="snInputProps_identifier + '-field'"
      :autofocus="snInputProps_autofocus"
      :class="snInputProps_classes"
      :error-messages="snInputProps_errorMessages"
      :placeholder="snInputProps_disabled ? null : placeholder"
      :hint="snInputProps_hint"
      :persistent-hint="!!snInputProps_hint ? true : null"
      :name="snInputProps_name"
      :required="snInputProps_required"
      :disabled="snInputProps_disabled"
      :aria-label="snInputProps_label"
      :rules="rules"
      type="tel"
      inputmode="text"
      autocomplete="nope"
      outlined
      @keydown="$emit('keydown'); clearField();"
      @keyup="validate()"
      @keyup.delete="response = ''"
      @blur="validate(); obfuscateResponse();"
      @focus="setResponse(); $emit('focus');"
    />
  </div>
</template>

<script>
import SnInputProps from '../props/SnInputProps'
import SnLabel from '~/components/snui/v2/snLabel/snLabel'

export default {
  name: 'SnSsn',
  components: { SnLabel },
  props: {
    ...SnInputProps,
    value: {
      type: [String, Number, Array],
      default: '',
      required: false
    },
    label: {
      type: String,
      default: ''
    },
    showOptionalLabel: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Array,
      default: () => [],
      required: false
    }
  },
  data () {
    return {
      response: '',
      finalResponse: '',
      placeholder: 'XXX-XX-XXXX'
    }
  },
  watch: {
    value (newVal) {
      this.finalResponse = newVal
      this.setResponse()
    },
    finalResponse (newVal) {
      this.$emit('input', this.finalResponse)
    }
  },
  created () {
    this.response = this.value
    this.obfuscateResponse()
  },
  methods: {
    setResponse () {
      this.response = this.finalResponse
    },
    obfuscateResponse () {
      this.finalResponse = this.response
      if (!!this.response && !this.response.includes('X')) {
        const value = this.response
          .replace(/\D+/g, '')

        const part1 = value.length > 2 ? `${value.substring(0, 3).replace(/[0-9]/g, 'X')}` : value
        const part2 = value.length > 3 ? `-${value.substring(3, 5).replace(/[0-9]/g, 'X')}` : ''
        const part3 = value.length > 5 ? `-${value.substring(5, 9)}` : ''
        this.response = `${part1}${part2}${part3}`
      }
      this.$emit('blur', this.finalResponse)
    },
    clearField () {
      if (!!this.response && this.response.includes('X')) this.response = ''
    },
    validate () {
      if (this.required && !this.response) return
      if (!!this.response && this.response.includes('X')) return

      const value = this.response
        .replace(/\D+/g, '')
      if (!value) {
        this.response = ''
        return
      }

      const part1 = value.length > 2 ? `${value.substring(0, 3)}` : value
      const part2 = value.length > 3 ? `-${value.substring(3, 5)}` : ''
      const part3 = value.length > 5 ? `-${value.substring(5, 9)}` : ''
      this.response = `${part1}${part2}${part3}`
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~/assets/css/snui/index.scss';

.sn-ssn {
  font-family: $font-family-primary !important;
  .v-input--is-disabled {
    ::v-deep .v-input__slot {
      background-color: $sn-gray-01;
      border: 1px solid $sn-gray-04 !important;
      .v-text-field__slot {
        input {
          color: $sn-primary-01 !important;
        }
      }
    }
  }
  ::v-deep {
    font-family: $font-family-primary !important;
    .v-input__slot {
      background-color: $sn-white;
      border: 1px solid $sn-gray-04;
      box-sizing: border-box;
      border-radius: 2px;
      min-height: 48px !important;

      & fieldset {
        border: none;
      }

      &:focus-within {
        border: 1px solid $sn-primary !important;
      }

      &:hover {
        border: 1px solid $sn-primary !important;
      }
    }
  }
  .error--text {
    ::v-deep .v-input__slot {
      border-color: $sn-error;

      &:hover {
        border-color: $sn-error !important;
      }
    }
  }
  ::v-deep .v-text-field__details {
    padding-left: 0 !important;
  }

  ::v-deep .v-text-field__slot {
    input {
      caret-color: $sn-primary;
    }
  }

  ::v-deep .v-messages {
    color: $sn-primary-01;

    .v-messages__message {
      font-size: 14px;
      line-height: 22px;
      margin-bottom: 20px;
    }

    &.error--text {
      font-size: 15px;
      display: inline-flex;
      align-items: center;
      visibility: visible;
      color: $sn-error !important;

      &:before {
        content: '\26A0';
        margin-right: 4px;
        margin-bottom: 22px;
        font-size: 18px;
        width: 24px;
        text-align: center;
      }

      .v-messages__wrapper {
        display: inline-flex;
        padding-bottom: 2px;
      }
    }
  }
}
</style>
